import Content, {IContent} from "@/model/Content/Content"
import hasInsurance, {IHasInsurance} from "@/model/mixins/Insurance/hasInsurance"


class InsuranceContentBase extends Content {
    private name: string
    private description?: string
    private image?: string
    private link?: string

    constructor(name: string, description?: string, image?: string, link?: string) {
        super()
        this.name = name
        this.description = description
        this.image = image
        this.link = link
    }

    public getName(): string {
        return this.name
    }
    public getDescription(): string | undefined | null {
        return this.description
    }
    public getImage(): string | undefined | null {
        return this.image
    }
    public getLink(): string | undefined | null {
        return this.link
    }

}

export interface IInsuranceContent extends InsuranceContentBase, IContent, IHasInsurance {
    getName(): string
    getDescription(): string | undefined | null
    getImage(): string | undefined | null
    getLink(): string | undefined | null
}


// apply mixins
const InsuranceContent: Constructor<IInsuranceContent> = hasInsurance(InsuranceContentBase)

export default InsuranceContent